import { useEffect } from "react";
import "./index.css";
import useWindowSize from "../../hooks/useWindowSizes";
import Footer from "./Footer";
import ScrollToTop from "../../components/ScrollToTop";
import clsx from "clsx";
import { useDispatch } from "react-redux";
import { setTopMenu } from "../../../redux/actions/topMenuActions";

const MainLayout = (props) => {
  const dispatch = useDispatch();
  const { children, breadcrumbs, title, hideFooter } = props;
  const size = useWindowSize();

  useEffect(() => {
    dispatch(
      setTopMenu({
        title,
        breadcrumbs,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [breadcrumbs, title]);

  useEffect(() => {
    const active = JSON.parse(localStorage.getItem("active_nav"));

    if (size.width < 1000) {
      document.getElementById("main-layout").style.paddingLeft = "0";
    } else {
      if (!active) {
        document.getElementById("main-layout").style.paddingLeft = "70px";
      } else {
        document.getElementById("main-layout").style.paddingLeft = "286px";
      }
    }
  }, [size]);

  return (
    <div id="main-layout" className={clsx("main-layout")}>
      <div className="content">{children}</div>
      <ScrollToTop />
      {!hideFooter && <Footer />}
    </div>
  );
};

export default MainLayout;

MainLayout.propTypes = {};

MainLayout.defaultProps = {};
